import React from 'react';
import { motion } from 'framer-motion';
import { LibraryIcon, LayersIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
const MOCKUP = 'https://cdn.magicpatterns.com/uploads/dJxML6sdS9Vd1dGLitULgq/ChatGPT_Image_6_sept_2026,_19_08_55.png';
const benefits = [{
  icon: LibraryIcon,
  label: '120 Classes'
}, {
  icon: LayersIcon,
  label: '6 Volumes'
}, {
  icon: DownloadIcon,
  label: '40+ Weeks of Material'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-85" data-mp="xano5xlbjdeb">
      <div className="relative mx-auto w-full max-w-content px-5 pb-8 pt-6 sm:px-8 sm:pb-12 sm:pt-8" data-id="element-86" data-mp="xb5whsl99i2l">
        <p className="text-center font-serif text-[0.7rem] uppercase tracking-label text-forest" data-id="element-87" data-mp="sde3ev8vjpwt">
          Yoga Teacher System<sup className="text-[0.55em]" data-id="element-88" data-mp="3d1ikzavvpeny">™</sup>
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-4 max-w-3xl text-center" data-id="element-89" data-mp="3d33h34xud5nx">
          <p className="mx-auto max-w-xs text-[0.6rem] font-semibold uppercase leading-relaxed tracking-label text-gold sm:max-w-md sm:text-xs" data-id="element-90" data-mp="3o7lrppymr4of">
            For yoga teachers tired of starting from scratch
          </p>

          <h1 className="mt-3 font-serif text-[1.85rem] font-semibold uppercase leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-91" data-mp="3e8wjkowjcyld">
            Stop planning every
            <span className="block text-forest" data-id="element-92" data-mp="358rbsdnfjy6o">yoga class from scratch.</span>
          </h1>

          <p className="mx-auto mt-3 max-w-xl text-[0.95rem] leading-snug text-muted sm:mt-5 sm:text-lg" data-id="element-93" data-mp="35akifsy1mieo">
            <span className="font-semibold text-ink" data-id="element-94" data-mp="2viy43nqes37p">
              120 complete Ready-to-Teach yoga classes
            </span>{' '}
            organized across 6 professional volumes — so your next class starts with a plan, not a
            blank page.
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} src={MOCKUP} alt="Yoga Teacher System — the six volume covers of the Ready-to-Teach class library" className="mx-auto mt-4 w-full max-w-4xl sm:mt-6" width={1536} height={1024} data-id="element-95" data-mp="2lml98mj4njbd" />

        <p className="mt-1 text-center font-serif text-sm uppercase tracking-label text-forest sm:text-lg" data-id="element-96" data-mp="1b1fd0vzaxsrj">
          Open <span className="text-gold" data-id="element-97" data-mp="162ued0zp7h57">•</span> Choose <span className="text-gold" data-id="element-98" data-mp="15zq0td0cf91v">•</span> Teach
        </p>

        <ul className="mt-5 grid grid-cols-3 gap-2 sm:mx-auto sm:max-w-2xl sm:gap-3" data-id="element-99" data-mp="111es55lsb4l8">
          {benefits.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex flex-col items-center gap-1.5 rounded-2xl border border-sandDark/70 bg-ivory/70 px-2 py-3 text-center sm:py-4" data-id="element-100" data-mp="x3h1dycd8afq">
              <Icon className="h-4 w-4 shrink-0 text-sage sm:h-5 sm:w-5" aria-hidden="true" data-id="element-101" data-mp="3htpyjt6msmmz" />
              <span className="text-[0.6rem] font-semibold uppercase leading-tight tracking-label text-ink sm:text-[0.7rem]" data-id="element-102" data-mp="1x7871tlc81wr">
                {label}
              </span>
            </li>)}
        </ul>

        <div className="mt-5" data-id="element-103" data-mp="2b0pmb26zqsgz">
          <CtaButton label="Get instant access" microcopy="One-Time Purchase • No Subscription • Instant Access" data-id="element-104" data-mp="2b0zdgt3rv5o9" />
        </div>
      </div>
    </header>;
}